import React, { Component } from 'react';
import { Card, Grid, Header, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import {
  canViewPanelReview,
  canViewPanelChairReview,
  withinPanelReviewDateRange,
} from 'go/security/permissions';
import {
  formatDateMMDDYYYY,
  getUniqs,
  getUnixtimeFromISO,
  ISOToDisplayDate,
  retrievePanelSessionsFromPermissions,
} from 'common/utils';
import REST from 'go/requests/rest';
import _ from 'lodash';

const dashboardUrl = 'panelReview/sessions';
const conductReviewText = 'Conduct Review';
const iconImg = 'file text'; // where is the icon found in the mock up?

export default class PanelReviewCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      panelSessions: [],
      foIds: [],
      fundingOpportunityData: [],
    };
  }

  componentDidMount() {
    const userPanelSessionIds = retrievePanelSessionsFromPermissions(
      this.props.permissions
    );

    let panelPromises = [];
    for (let i = 0; i < userPanelSessionIds.length; i++) {
      panelPromises.push(
        this.getPanelSession(userPanelSessionIds[i]).catch((e) => {
          console.error('error');
          return null;
        })
      );
    }
    Promise.all(panelPromises)
      .then((panelSessions) => {
        const sessionsCompleted = _.compact(panelSessions);
        const foIds = getUniqs(sessionsCompleted, 'fundingOpportunityId');
        this.setState({
          panelSessions: sessionsCompleted,
          foIds,
        });
      })
      .catch((error) => {
        this.setState({
          error: true,
          panelSessions: [],
        });
      });
  }

  getPanelSession = (sessionId) => {
    return REST.panelReviewV2
      .getPanelSessionInfo(this.props.jwt, sessionId)
      .then(REST.handler.handleResponse);
  };

  getFoName = (foId) => {
    return REST.fundingOpportunity
      .getFundingOpportunity(this.props.jwt, foId)
      .then(REST.handler.handleResponse)
      .then((responseJson) => {
        this.setState({
          fundingOpportunityData: [
            ...this.state.fundingOpportunityData,
            {
              fundingOpportunityId: responseJson.fundingOpportunityId,
              fundingOpportunityName: responseJson.fundingOpportunityName,
              programName: responseJson.programName,
            },
          ],
        });
        return this.state.fundingOpportunityData;
      })
      .catch((err) => {
        console.error('error fetching FO ');
      });
  };

  renderCard({ startDate, endDate, location, sessionId, previewDate }, index) {
    const { fundingOpportunityData } = this.state;
    const startDateValue = new Date(startDate);
    const endDateValue = new Date(endDate);

    const startDateStr = ISOToDisplayDate(startDateValue, {
      showDate: true,
      showHours: true,
      showTimeZone: true,
    });

    const endDateStr = ISOToDisplayDate(endDateValue, {
      showDate: true,
      showHours: true,
      showTimeZone: true,
    });

    const todayDateUnixtime = getUnixtimeFromISO();
    const startDateUnixtime = getUnixtimeFromISO(startDate);
    const endDateUnixtime = getUnixtimeFromISO(endDate);
    const canViewCard = withinPanelReviewDateRange(previewDate, endDate);
    const activeSession =
      todayDateUnixtime >= startDateUnixtime && startDateUnixtime <= endDateUnixtime;

    // the index # (corresponding to this panel card),
    // doesn't necessarily match the element # returned in fundingOpportunityData,
    // so we need to match the fo id# for this index with a match from fundingOpportunityData
    const foWithMatchingOpportunityId = _.find(fundingOpportunityData, (fo) => {
      if (
        fo.fundingOpportunityId &&
        fo.fundingOpportunityId === this.state.panelSessions[index].fundingOpportunityId
      ) {
        return true;
      }
    });

    const foNameText = `${_.get(
      foWithMatchingOpportunityId,
      'fundingOpportunityName',
      ''
    )} Funding Opportunity`;

    const programText = `${_.get(this.state.panelSessions, [index, 'sessionName'], '')}`;
    const ariaReviewText = `Conduct ${programText} Review`;
    const appDevAndSubToggle = _.includes(this.props.toggles, 'appDevAndSub1-1');

    let upcomingCopyText = `Congratulations! You are successfully registered for the panel event from ${startDateStr} to ${endDateStr} for the ${foNameText} in ${location}.`;
    let activeCopyText = `You have an active panel review from ${startDateStr} to ${endDateStr} for the ${foNameText} in ${location}.`;

    if (appDevAndSubToggle) {
      return canViewCard ? (
        <Grid.Column key={sessionId}>
          <Card fluid className='homepage homepage-card'>
            <Card.Content className="leadParagraph">
              <h4>{programText}</h4>
              {activeSession ? (
                <div>
                  <h5>{foNameText}</h5>
                  <p><span>Start date:</span> {` ${startDateStr}`}</p>
                  <p><span>End date:</span> {` ${endDateStr}`}</p>
                  <Link
                    to={`/${dashboardUrl}/${sessionId}/tasks`}
                    aria-label={`${ariaReviewText}`}
                    id="homepage-link"
                  >
                    {conductReviewText}
                  </Link>
                </div>
              ) : (
                <p>{upcomingCopyText}</p>
              )}
            </Card.Content>
          </Card>
        </Grid.Column>
      ) : null;
    } else {
      return canViewCard ? (
        <Grid.Column width={6} key={sessionId}>
          <Card fluid>
            <Card.Content className="leadParagraph">
              <Header as="h3">
                <Icon name={iconImg} size="small" />
                {programText}
              </Header>
              <p>{activeSession ? activeCopyText : upcomingCopyText}</p>
            </Card.Content>
            {activeSession ? (
              <Card.Content>
                <Grid columns={2}>
                  <Grid.Row textAlign={'right'}>
                    <Grid.Column />
                    <Grid.Column>
                      <Link
                        to={`/${dashboardUrl}/${sessionId}/tasks`}
                        aria-label={`${ariaReviewText}`}
                      >
                        {conductReviewText}
                      </Link>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Card.Content>
            ) : null}
          </Card>
        </Grid.Column>
      ) : null;
    }

  }

  renderCards() {
    if (this.state.panelSessions && this.state.panelSessions.length > 0) {
      let panelCards = [];
      for (let i = 0; i < this.state.panelSessions.length; i++) {
        if (
          canViewPanelReview(this.props.permissions, this.state.panelSessions[i], true)
        ) {
          let panelCard = this.renderCard(this.state.panelSessions[i], i);
          panelCards.push(panelCard);
        }
      }
      return panelCards;
    }
    return null;
  }

  render() {
    if (this.state.foIds.length && !this.state.fundingOpportunityData.length) {
      _.map(this.state.foIds, (foId) => {
        return this.getFoName(foId);
      });
    }

    const appDevAndSubToggle = _.includes(this.props.toggles, 'appDevAndSub1-1');

    let panelCards = this.renderCards();
   
    if (panelCards !== null) {
      return (
        <React.Fragment>
          {(appDevAndSubToggle && panelCards.length) ? (<Grid.Row className='homepage'><h3>My competitive merit reviews</h3></Grid.Row>) : <></>}
          <Grid columns="equal" stackable padded="vertically" className={appDevAndSubToggle ? "homepage-grid" : "" }><Grid.Row columns={3}>{panelCards}</Grid.Row></Grid>
        </React.Fragment>
      );
    } else {
      return null;
    }
  }
}
